import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api/client";
import { Status } from "../components/Ui";

export default function Orders() {
  const [orders, setOrders] = useState(null);
  const [page, setPage] = useState(1);

  useEffect(() => {
    api.get(`/order/mine?page=${page}`).then((r) => setOrders(r.data.orders)).catch(() => setOrders([]));
  }, [page]);

  return (
    <div className="container" style={{ maxWidth: 760, padding: "32px 16px" }}>
      <h1 style={{ fontSize: 24 }}>Your orders</h1>

      {orders === null && <p className="muted">Loading…</p>}
      {orders && orders.length === 0 && (
        <div className="card center" style={{ padding: 48 }}>
          <p className="muted">You haven't ordered anything yet.</p>
          <Link to="/" style={{ color: "var(--brand)", fontWeight: 800 }}>Browse games</Link>
        </div>
      )}

      <div className="list">
        {(orders || []).map((o) => (
          <Link key={o.orderId} to={`/orders/${o.orderId}`} className="row">
            <div className="grow">
              <div className="truncate" style={{ fontWeight: 700 }}>{o.p_info}</div>
              <div className="muted small">{o.amount} · {new Date(o.createdAt).toLocaleDateString()} · #{o.orderId}</div>
            </div>
            <div className="tabular" style={{ fontWeight: 800 }}>₹{o.price}</div>
            <Status value={o.status} />
          </Link>
        ))}
      </div>

      {orders && orders.length === 20 && (
        <button className="btn ghost" style={{ width: "100%", marginTop: 24 }} onClick={() => setPage((p) => p + 1)}>
          Load more
        </button>
      )}
    </div>
  );
}
